document.addEventListener('alpine:init', () => {
  Alpine.data('ProductMp3Player', () => ({
    songs: [],
    currentName: '',
    progress: 0,
    audio: null,
    slider: null,
    _onTimeUpdate: null,
    _onLoadedMetadata: null,
    _onPlay: null,
    _onSliderInput: null,

    init() {
      this.songs = JSON.parse(this.$refs.songs.textContent);

      if (!window.Amplitude || !this.songs.length) return;

      Amplitude.init({
        songs: this.songs,
      });

      this.slider = this.$refs.slider;
      this.audio = Amplitude.getAudio();

      this._onTimeUpdate = () => this.setProgress();
      this._onLoadedMetadata = () => {
        this.setProgress();
        this.setCurrentName();
      };
      this._onPlay = () => this.setCurrentName();
      this._onSliderInput = () => {
        if (!this.slider) return;
        this.progress = Number(this.slider.value) || 0;
      };

      if (this.audio) {
        this.audio.addEventListener('timeupdate', this._onTimeUpdate);
        this.audio.addEventListener('loadedmetadata', this._onLoadedMetadata);
        this.audio.addEventListener('play', this._onPlay);
      }

      if (this.slider) {
        this.slider.addEventListener('input', this._onSliderInput);
      }

      this.setProgress();
      this.setCurrentName();
    },

    destroy() {
      if (this.audio) {
        this.audio.removeEventListener('timeupdate', this._onTimeUpdate);
        this.audio.removeEventListener('loadedmetadata', this._onLoadedMetadata);
        this.audio.removeEventListener('play', this._onPlay);
      }

      if (this.slider) {
        this.slider.removeEventListener('input', this._onSliderInput);
      }
    },

    setProgress() {
      this.progress =
        this.audio && this.audio.duration
          ? (this.audio.currentTime / this.audio.duration) * 100
          : 0;
    },

    setCurrentName() {
      const meta = Amplitude.getActiveSongMetadata();
      this.currentName = meta && meta.name ? meta.name : '';
    },
  }));
});
